// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__kfS8C","head":"ProcedureTableInfo_head__mHnzF"};